export const countryCodes = [
  { code: "US", name: "United States", dial: 1 },
  { code: "GB", name: "United Kingdom", dial: 44 },
  { code: "CA", name: "Canada", dial: 1 },
  { code: "AU", name: "Australia", dial: 61 },
  { code: "DE", name: "Germany", dial: 49 },
  { code: "FR", name: "France", dial: 33 },
  { code: "IN", name: "India", dial: 91 },
  { code: "CN", name: "China", dial: 86 },
  { code: "JP", name: "Japan", dial: 81 },
  { code: "BR", name: "Brazil", dial: 55 },
  { code: "MX", name: "Mexico", dial: 52 },
  { code: "IT", name: "Italy", dial: 39 },
  { code: "ES", name: "Spain", dial: 34 },
  { code: "NL", name: "Netherlands", dial: 31 },
  { code: "SE", name: "Sweden", dial: 46 },
  { code: "NO", name: "Norway", dial: 47 },
  { code: "DK", name: "Denmark", dial: 45 },
  { code: "FI", name: "Finland", dial: 358 },
  { code: "CH", name: "Switzerland", dial: 41 },
  { code: "AT", name: "Austria", dial: 43 },
  { code: "BE", name: "Belgium", dial: 32 },
  { code: "PT", name: "Portugal", dial: 351 },
  { code: "IE", name: "Ireland", dial: 353 },
  { code: "PL", name: "Poland", dial: 48 },
  { code: "CZ", name: "Czech Republic", dial: 420 },
  { code: "RO", name: "Romania", dial: 40 },
  { code: "HU", name: "Hungary", dial: 36 },
  { code: "GR", name: "Greece", dial: 30 },
  { code: "RU", name: "Russia", dial: 7 },
  { code: "UA", name: "Ukraine", dial: 380 },
  { code: "TR", name: "Turkey", dial: 90 },
  { code: "SA", name: "Saudi Arabia", dial: 966 },
  { code: "AE", name: "United Arab Emirates", dial: 971 },
  { code: "QA", name: "Qatar", dial: 974 },
  { code: "KW", name: "Kuwait", dial: 965 },
  { code: "BH", name: "Bahrain", dial: 973 },
  { code: "OM", name: "Oman", dial: 968 },
  { code: "IL", name: "Israel", dial: 972 },
  { code: "EG", name: "Egypt", dial: 20 },
  { code: "ZA", name: "South Africa", dial: 27 },
  { code: "NG", name: "Nigeria", dial: 234 },
  { code: "KE", name: "Kenya", dial: 254 },
  { code: "GH", name: "Ghana", dial: 233 },
  { code: "KR", name: "South Korea", dial: 82 },
  { code: "SG", name: "Singapore", dial: 65 },
  { code: "MY", name: "Malaysia", dial: 60 },
  { code: "TH", name: "Thailand", dial: 66 },
  { code: "VN", name: "Vietnam", dial: 84 },
  { code: "PH", name: "Philippines", dial: 63 },
  { code: "ID", name: "Indonesia", dial: 62 },
  { code: "PK", name: "Pakistan", dial: 92 },
  { code: "BD", name: "Bangladesh", dial: 880 },
  { code: "LK", name: "Sri Lanka", dial: 94 },
  { code: "NP", name: "Nepal", dial: 977 },
  { code: "NZ", name: "New Zealand", dial: 64 },
  { code: "AR", name: "Argentina", dial: 54 },
  { code: "CL", name: "Chile", dial: 56 },
  { code: "CO", name: "Colombia", dial: 57 },
  { code: "PE", name: "Peru", dial: 51 },
  { code: "VE", name: "Venezuela", dial: 58 },
  { code: "EC", name: "Ecuador", dial: 593 },
  { code: "CR", name: "Costa Rica", dial: 506 },
  { code: "PA", name: "Panama", dial: 507 },
  { code: "DO", name: "Dominican Republic", dial: 1 },
  { code: "JM", name: "Jamaica", dial: 1 },
  { code: "TT", name: "Trinidad and Tobago", dial: 1 },
  { code: "IS", name: "Iceland", dial: 354 },
  { code: "LU", name: "Luxembourg", dial: 352 },
  { code: "MT", name: "Malta", dial: 356 },
  { code: "CY", name: "Cyprus", dial: 357 },
  { code: "BG", name: "Bulgaria", dial: 359 },
  { code: "HR", name: "Croatia", dial: 385 },
  { code: "SK", name: "Slovakia", dial: 421 },
  { code: "SI", name: "Slovenia", dial: 386 },
  { code: "LT", name: "Lithuania", dial: 370 },
  { code: "LV", name: "Latvia", dial: 371 },
  { code: "EE", name: "Estonia", dial: 372 },
  { code: "RS", name: "Serbia", dial: 381 },
  { code: "BA", name: "Bosnia and Herzegovina", dial: 387 },
  { code: "MK", name: "North Macedonia", dial: 389 },
  { code: "AL", name: "Albania", dial: 355 },
  { code: "GE", name: "Georgia", dial: 995 },
  { code: "AM", name: "Armenia", dial: 374 },
  { code: "AZ", name: "Azerbaijan", dial: 994 },
  { code: "KZ", name: "Kazakhstan", dial: 7 },
  { code: "UZ", name: "Uzbekistan", dial: 998 },
  { code: "MA", name: "Morocco", dial: 212 },
  { code: "TN", name: "Tunisia", dial: 216 },
  { code: "JO", name: "Jordan", dial: 962 },
  { code: "LB", name: "Lebanon", dial: 961 },
  { code: "IQ", name: "Iraq", dial: 964 },
  { code: "HK", name: "Hong Kong", dial: 852 },
  { code: "TW", name: "Taiwan", dial: 886 },
  { code: "MM", name: "Myanmar", dial: 95 },
  { code: "KH", name: "Cambodia", dial: 855 },
  { code: "LA", name: "Laos", dial: 856 },
  { code: "UY", name: "Uruguay", dial: 598 },
  { code: "PY", name: "Paraguay", dial: 595 },
  { code: "BO", name: "Bolivia", dial: 591 },
  { code: "GT", name: "Guatemala", dial: 502 },
  { code: "HN", name: "Honduras", dial: 504 },
  { code: "SV", name: "El Salvador", dial: 503 },
  { code: "NI", name: "Nicaragua", dial: 505 },
  { code: "CU", name: "Cuba", dial: 53 },
  { code: "PR", name: "Puerto Rico", dial: 1 },
  { code: "TZ", name: "Tanzania", dial: 255 },
  { code: "UG", name: "Uganda", dial: 256 },
  { code: "ET", name: "Ethiopia", dial: 251 },
  { code: "CM", name: "Cameroon", dial: 237 },
  { code: "SN", name: "Senegal", dial: 221 },
  { code: "CI", name: "Ivory Coast", dial: 225 },
  { code: "MG", name: "Madagascar", dial: 261 },
  { code: "MU", name: "Mauritius", dial: 230 },
  { code: "FJ", name: "Fiji", dial: 679 },
  { code: "BN", name: "Brunei", dial: 673 },
  { code: "MV", name: "Maldives", dial: 960 },
  { code: "AF", name: "Afghanistan", dial: 93 },
  { code: "MN", name: "Mongolia", dial: 976 },
];
